<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 个人设置
                </el-breadcrumb-item>
				<el-breadcrumb-item>我的业绩</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.status" placeholder="请选择状态" >
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option v-for="item in statusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-date-picker
						type="month"
						placeholder="月份"
						v-model="query.totalMonth"
						value-format="yyyy-MM"
				></el-date-picker>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="totalMonth" label="月份"></el-table-column>
				<el-table-column prop="userName" label="员工姓名" width="100"></el-table-column>
                <el-table-column prop="orderNum" label="订单量"></el-table-column>
				<el-table-column prop="orderAmount" label="订单金额"></el-table-column>
				<el-table-column prop="profit" label="利润"></el-table-column>
				<el-table-column prop="profitRate" label="利润率"></el-table-column>
				<el-table-column prop="commission" label="提成"></el-table-column>
				<el-table-column prop="teamOrderAmount" label="组成员订单金额" width="200"></el-table-column>
				<el-table-column prop="teamCommission" label="组内提成"></el-table-column>
				<el-table-column prop="status" label="状态" width="90">
					<template slot-scope="scope">
						{{statusFormat(null, null, scope.row.status)}}
					</template>
				</el-table-column>
                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-check"
                            @click="handleConfirm(scope.$index, scope.row)"
							v-if = "controll['confirm'] && scope.row.status == 1"
                        >确认</el-button>
                    </template>
                </el-table-column>
            </el-table>
			
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div> 

		<el-dialog v-dialogDrag :close-on-click-modal=false title="详情" :visible.sync="showVisible" width="70%">
			<el-tabs v-model="activeName" type="card">
				<el-tab-pane label="基本信息" name="baseTab">
					<el-form ref="show" :model="show" label-width="120px">
						<el-descriptions class="margin-top" title="" :column="2" size="medium" labelStyle="width:150px;" border>
							<el-descriptions-item>
								<template slot="label">
									业绩月份
								</template>
								{{show.totalMonth}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									员工姓名
								</template>
								{{show.userName}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									新增客户数
								</template>
								{{show.newCustomerNum}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									订单量
								</template>
								{{show.orderNum}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									订单金额
								</template>
								{{show.orderAmount}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									利润
								</template>
								{{show.profit}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									利润率
								</template>
								{{show.profitRate}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									业务提成比例
								</template>
								{{show.businessCommissionScale}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									提成
								</template>
								{{show.commission}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									状态
								</template>
								{{statusFormat(null, null, show.status)}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									备注
								</template>
								{{show.remark}}
							</el-descriptions-item>
						</el-descriptions>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="内容信息" name="detailTab">
					<el-table
						:data="detailData"
						border
						class="table"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						height="400px"
						stripe
					>
						<el-table-column prop="orderNo" label="订单号" width="130"></el-table-column>
						<el-table-column prop="companyName" label="公司名称" width="280"></el-table-column>
						<el-table-column prop="taxIncluded" label="是否含税" width="80">
							<template slot-scope="scope">
								{{scope.row.taxIncluded?'含税':'不含税'}}
							</template>
						</el-table-column>
						<el-table-column prop="productName" label="型号"></el-table-column>
						<el-table-column prop="num" label="数量" width="80"></el-table-column>
						<el-table-column prop="amount" label="金额" width="120"></el-table-column>
						<el-table-column prop="cost" label="成本" width="120"></el-table-column>
						<el-table-column prop="profit" label="利润" width="80"></el-table-column>
						<el-table-column prop="commission" label="提成" width="80"></el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showVisible = false">取 消</el-button>
            </span>
        </el-dialog>

		<el-dialog v-dialogDrag :close-on-click-modal=false title="确认信息" :visible.sync="confirmVisible" width="40%">
            <el-form ref="show" :model="show" label-width="120px">
				<el-row>
					<el-col :span="12">
						<el-form-item label="工资月份：">
							{{show.totalMonth}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="员工姓名：">
							{{show.userName}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="业绩提成：">
							{{show.commission}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="组内提成：">
							{{show.teamCommission == null?0:show.teamCommission}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="备注：">
					<el-input type=textarea :rows=3 v-model="show.remark"> </el-input>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>		
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchAchievementPersonalData, getAchievement, getUserKV, confirmAchievement } from '../../../api/index';
export default {
    name: 'my-achievement',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
			showVisible: false,
			confirmVisible: false,
			detailData:[],
			activeName:"baseTab",
            pageTotal: 0,
			show:{},
			statusKV:[{"key":0,"value":"待推送"},{"key":1,"value":"已推送"},{"key":2,"value":"已确认"},{"key":3,"value":"已核算"}],
			userKV:[],
			controll:{}
        };
    },
    created() {
		this.controll = getControll("my-achievement");
		this.getUser();
        this.getData();
    },
    methods: {
		statusFormat(row, column, cellValue) {
			let statusConfig = {"0":"待推送", "1":"待确认", "2":"已确认", "3":"已核算"};
			return statusConfig[cellValue];
		},
		getUser() {
			getUserKV().then(res => {
				if (res.code == 0 ) {
					this.userKV = res.data;
				} else {
					this.$message.error("获取用户信息失败，" + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchAchievementPersonalData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		handleConfirm(index, row) {
			this.show = row;
			this.confirmVisible = true;
		},
		confirm() {
			this.$confirm('确定提交吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					let data = {};
					data["id"] = this.show.id;
					data["remark"] = this.show.remark;
					confirmAchievement(data).then(res => {
						if (res.code == 0) {
							this.$message.success('确认成功');
							this.confirmVisible = false;
							this.getData();
						} else {
							this.$message.error(`确认失败！` + res.message);
						}
					});
                })
                .catch(() => {});
		},
		//详情操作
		handleShow(index, row) {
			getAchievement(row.id).then(res => {
				if (res.code == 0) {
				    this.show = row;
					this.detailData = res.data.details;
					this.showVisible = true;
				} else {
					this.$message.error(`获取详情失败！` + res.message);
				}
			});
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
